import { Component, effect, input, output } from "@angular/core";
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-change-language",
  imports: [TranslatePipe, ReactiveFormsModule],
  templateUrl: "./change-language.component.html",
  styles: ``,
})
export class ChangeLanguageComponent {
  supportedLanguages = new Map<string, string>([
    ["de", "Deutsch"],
    ["en", "English"],
  ]);

  currentLanguage = input.required<string>();

  changeLanguage = output<{ language: string }>();
  busy = input<boolean>(false);

  language = new FormControl<string>("de", [Validators.required]);

  form = new FormGroup({
    language: this.language,
  });

  constructor() {
    effect(() => {
      const currentLanguage = this.currentLanguage();
      if (this.supportedLanguages.has(currentLanguage)) {
        this.language.setValue(currentLanguage);
      }
    });
  }

  submit() {
    if (this.form.valid) {
      this.changeLanguage.emit({
        language: this.language.value || "",
      });
    }
  }
}
